import React from 'react';
import { WrapperButtonsSearch } from './style';

export default function ButtonsSearch() {
  return (
    <WrapperButtonsSearch>
      <button className="search">Pesquisar</button>
      <button className="clear">Limpar</button>
    </WrapperButtonsSearch>
  );
}
